import React, { useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { getText } from 'services/languageService';
import { setOpenSubstrModalAction } from 'store/actions/mainPage';
import {
  Box,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { setSubstrateLayerAction } from 'store/actions/map';

export const LayersModal: React.FC = (): JSX.Element => {
  const { openSubstrateModal } = useAppSelector((state) => state.mainPage);
  const dispatch = useAppDispatch();
  const modalRef = useRef<null | HTMLInputElement>(null);

  const [layer, setLayer] = useState('osm');

  const handleClose = () => {
    dispatch(setOpenSubstrModalAction(false));
  };

  const changeSubstrateLayer = (event: any) => {
    setLayer(event.target.value);
    dispatch(setSubstrateLayerAction(event.target.value));
  };
  useOutsideClick(modalRef, handleClose);

  return openSubstrateModal ? (
    <Box
      ref={modalRef}
      sx={{
        position: 'absolute',
        top: 0,
        right: '40px',
        backgroundColor: (theme) => theme.palette.grey[300],
        width: '200px',
        zIndex: 1600,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ml: 1,
        }}
      >
        <Typography>{getText('SUBSTRATE_LAYER')}</Typography>
        <IconButton onClick={handleClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Box>
      <FormControl>
        <RadioGroup
          sx={{ p: '0px 8px 16px' }}
          defaultValue={layer}
          onChange={changeSubstrateLayer}
        >
          <FormControlLabel value="osm" control={<Radio />} label="OSM" />
          <FormControlLabel value="topo" control={<Radio />} label="OSM FR" />
          <FormControlLabel
            value="empty"
            control={<Radio />}
            label={getText('EMPTY_SUBSTRATE')}
          />
        </RadioGroup>
      </FormControl>
    </Box>
  ) : (
    <></>
  );
};
